import { render, staticRenderFns } from "./SwitchWrapper.vue?vue&type=template&id=204c4f4a"
import script from "./SwitchWrapper.vue?vue&type=script&lang=ts"
export * from "./SwitchWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports